import React from 'react';
import { Menu, Settings, MapPin } from 'lucide-react';
import { Button } from '../ui/button';
import RealTimeIndicator from './RealTimeIndicator';
import LanguageSwitcher from './LanguageSwitcher';
import { useLanguage } from '../../contexts/LanguageContext';

export const Header = ({ 
  sidebarOpen,
  setSidebarOpen,
  onSettingsClick 
}) => {
  const { t } = useLanguage();
  const currentTime = new Date().toLocaleString('en-IN', {
    dateStyle: 'medium',
    timeStyle: 'short'
  });

  return (
    <header className="bg-card border-b border-border px-3 sm:px-6 py-3 sm:py-4">
      <div className="flex items-center justify-between gap-2 sm:gap-4">
        {/* Left section */}
        <div className="flex items-center gap-2 sm:gap-4 flex-1 min-w-0">
          <Button
            variant="ghost"
            size="icon"
            className="md:hidden flex-shrink-0"
            onClick={() => setSidebarOpen(!sidebarOpen)}
          >
            <Menu className="w-5 h-5" />
          </Button>
          
          {/* Location Info - Responsive */}
          <div className="flex items-center gap-2 sm:gap-3 px-2 sm:px-4 py-1.5 sm:py-2 bg-primary/5 rounded-lg border border-primary/20">
            <MapPin className="w-4 h-4 sm:w-5 sm:h-5 text-primary flex-shrink-0" />
            <div className="min-w-0">
              <p className="text-xs sm:text-sm font-semibold text-foreground truncate">{t('header.location')}</p>
              <p className="text-[10px] sm:text-xs text-muted-foreground truncate hidden xs:block">{t('header.region')}</p>
            </div>
          </div>
        </div>
        
        {/* Right section */}
        <div className="flex items-center gap-1 sm:gap-3 flex-shrink-0">
          {/* Last updated time - Hidden on mobile */}
          <div className="hidden lg:block text-sm text-muted-foreground">
            <span className="font-medium">{t('header.lastUpdated')}:</span> {currentTime}
          </div>
          
          {/* Real-time controls */}
          <div className="hidden sm:flex">
            <RealTimeIndicator />
          </div>
          
          {/* Language Switcher */}
          <LanguageSwitcher />
          
          {/* Settings */}
          <Button variant="ghost" size="icon" onClick={onSettingsClick} className="h-8 w-8">
            <Settings className="w-4 h-4 sm:w-5 sm:h-5" />
          </Button>
        </div>
      </div>
    </header>
  );
};

export default Header;